import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
@Component({
  selector: 'app-manageelearning',
  templateUrl: './manageelearning.component.html',
  styleUrls: ['./manageelearning.component.css']
})
export class ManageelearningComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit() {
  }

  onChildData(event :any){
    this.router.navigate([event]);
    }
}
